import { FC } from 'react';
import { safeCharacterName } from '../../../../../../../shared/common/utils';
import { Link } from '../../../../../../../shared/frontend/components/link';

export const RecruitmentCharacterTitle: FC<any> = ({ profile, character }) => {
  return (
    <Link to={character.path + '/recruitment'} className="text-white">
      <div className={`d-inline class-color--${character.class?.id}`}>{safeCharacterName(character.name || '')}</div>
    </Link>
  );
};

export const RecruitmentGuildTitle: FC<any> = ({ profile, guild }) => {
  return (
    <Link to={guild?.path + '/recruitment'} className="text-white">
      <div className={`d-inline rio-faction-color--${guild.faction}`}>{`<${guild.name}>`}</div>
    </Link>
  );
};

export const RecruitmentTeamTitle: FC<any> = ({ profile, team }) => {
  return (
    <Link to={team?.path + '/recruitment'} className="text-white">
      <div className={`d-inline rio-faction-color--${team.faction}`}>{`<${team.name}>`}</div>
    </Link>
  );
};
